import ScansGroupedReport from "./ScansGroupedReport";

export default function ScanByBunk() {
  return (
    <ScansGroupedReport
      title="Scan by Bunk"
      subtitle="Scans grouped by the bunk (retail outlet) the QR / fuel access belongs to."
      dimension="retail_outlet"
      dropdownLabel="Retail Outlet"
      dropdownPlaceholder="All retail outlets"
      dropdownApiPath="/master/retail_outlets"
    />
  );
}
